export default __webpack_public_path__ + "0278a49f9007106a0bf49030d0f9c142.woff2";